import { AfterViewInit, ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, UrlSegment } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { MapService } from 'src/app/services/map.service';
import { environment } from "./../../../../environments/environment";
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';

interface Cervezas{
  value: number;
  name: string;
}
interface Clientes{
  value: number;
  name: string;
}
interface Estados{
  value: number;
  name: string;
}

@Component({
  selector: 'app-ver-establecimiento',
  templateUrl: './ver-establecimiento.component.html',
  styleUrls: ['./ver-establecimiento.component.css']
})
export class VerEstablecimientoComponent implements OnInit, OnDestroy{

  lat: number = 43.0081016;
  lng: number = -7.5561412;
  latOriginal: number = 0;
  lngOriginal: number = 0;
  zoom: number = 12;
  searchPlace: string = "";
  addressData: any;

  etiqueta: string = "";
  identificador: string = "";
  file: File | undefined
  imageUrl: string | ArrayBuffer | null = null;
  showImageErrorMessage: boolean = false;
  establishmentData: any = []; //Información de los establecimientos y dispositivos
  errorMessage : string =""; //Mensaje de error
  currentPath: string = ""; //Ruta actual
  establecimientoId: number = 0; //Id del dispositivo que está en la ruta
  establecimientoActual: any = []; //Dispositivos que estamos editando
  nombreCliente: string = "";
  est_img_path: string = "";
  usuarioEmail: string = "";
  establecimientoDispositivos: any = [];
  numeroDispositivos: number = 0;
  pageSizeOptions: number[] = [5, 10, this.numeroDispositivos];
  showEtiquetaError: boolean = false;
  establecimientoEditado: boolean = false;
  waitAfterSave: boolean = false;
  tiempoEsperaRecarga: number = 60000;
  showClienteError: boolean = false;
  telefonoError: boolean = false;
  errorEmail: boolean = false;
  showNoImageError: boolean = false;
  clienteDelEstablecimiento: string = "";
  disableSelect = new FormControl(false);
  userData: any = [];
  noHayImage: boolean = false;

  clientsData: any = [];
  clientes: Clientes[] = [
  ];
  selectedCliente: number | undefined;

  estado: Estados[] = [
    {value: 0, name: 'Desactivado'},
    {value: 1, name: 'Activado'}
  ];
  selectedEstado: number =  1;

  signin: FormGroup = new FormGroup({
    contacto: new FormControl(''),
    telefono: new FormControl(''),
    email: new FormControl('', [Validators.email]),
  });

  dataSource :any;
  displayedColumns: string[] = ['dev_reference', 'dev_label', 'clientId', 'dev_create_at','operaciones'];

  cervezas: Cervezas[] = []
  cervezasControl: FormControl = new FormControl();
  map: any; 
  marker: any;

  //RECARGAS
  recargas: any = [];
  devices: any = [];
  dataSourceRecargas :any;
  displayedColumnsRecargas: string[] = ['tank_num', 'dev_reference', 'dev_label', 'f_inicio', 'output_type', 'beertype','litres_output', 'litres_input'];

  //Subscriptions
  private establishmentSubscription: Subscription | undefined;
  private beerTypesSubscription: Subscription | undefined;
  private clientsSubscription: Subscription | undefined;
  private recargasSubscription: Subscription | undefined;

  @ViewChild('sort1') sort1!: MatSort;
  @ViewChild('sort2') sort2!: MatSort;
  @ViewChild('paginator1') paginator1!: MatPaginator;
  @ViewChild('paginator2') paginator2!: MatPaginator;

  urlBase: string = "";

  constructor(private deviceService: DeviceService, private router: Router, 
  private formBuilder: FormBuilder, private userService: UserService, private error429: Error429Service,
  private userDataService: UserDataService, private mapService: MapService,
  private cdr: ChangeDetectorRef){
    this.currentPath = this.router.url;
    this.userData = this.userDataService.getUserData();
    this.urlBase = environment.urlNonce;
  }

  ngOnInit(): void {
    if(this.userData.pro_id != "4"){
      this.displayedColumns = ['dev_reference', 'dev_label', 'dev_create_at','operaciones'];
    }
    this.clientsSubscription = this.userService.getClients().subscribe({
      next:resp =>{
        this.clientsData = resp;
        for(let i=0; i<resp.length; i++){
          this.clientes.push({
            value: resp[i].id,
            name: resp[i].razon_social
          });
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        this.establishmentSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
          next:resp =>{
            this.establishmentData = resp;
            for(let i=0; i<this.establishmentData.length; i++){
              if(this.establishmentData[i].id == this.establecimientoId){
                this.establecimientoActual = this.establishmentData[i];
              }
            }
          },error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          },complete: () =>{
            console.log(this.establecimientoActual);
            //RECARGAS
            this.devices = this.establecimientoActual.devices;
            let establecimientoId: any = [];
            establecimientoId.push(this.establecimientoActual.id);
            const recargasData = new FormData();
            recargasData.append('establishments', JSON.stringify(establecimientoId));
            console.log(JSON.stringify(establecimientoId));
            this.recargasSubscription = this.deviceService.getRecargas(recargasData).subscribe({
              next: resp => {
                console.log(resp);
                for(let i = 0; i < resp.charges.length; i++){
                  let tipo = "No encotrado";
                  if(resp.charges[i].output_type == 1){
                    tipo = "Retirada normal";
                  } 
                  if(resp.charges[i].output_type == 2){
                    tipo = "Retirada por incidencia";
                  } 
                  this.recargas.push({
                    dev_reference: this.obtenerDeviceReference(resp.charges[i].device_id),
                    dev_label: this.obtenerDeviceLabel(resp.charges[i].device_id),
                    f_inicio: resp.charges[i].charged_at,
                    tank_num: resp.charges[i].tank_num,
                    est_id: resp.charges[i].establishment_id,
                    dev_id: resp.charges[i].device_id,
                    litres_input: this.soloDosDecimalesConComa(resp.charges[i].litres_input),
                    litres_output: this.soloDosDecimalesConComa(resp.charges[i].litres_output),
                    output_type: tipo,
                    beertype: resp.charges[i].beertype.name,
                  });
                }
              },error: err => {
                console.log(err.error)
                if (err.status == 429) {
                  this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                  this.recargarPaginaDespuesDeTiempo();
                } else {
                  this.errorMessage = err.error.message;
                }
              },complete: () => {
                this.dataSourceRecargas = new MatTableDataSource(this.recargas);
                //Filtrado personalizado
                this.dataSourceRecargas.filterPredicate = (data: any, filter: string) => {
                  const dataStr = this.displayedColumns
                    .filter(key => key !== 'est_id' && key !== 'dev_id')
                    .map(key => data[key])
                    .join('')
                    .toLowerCase();
              
                  return dataStr.includes(filter);
                };
                setTimeout(() => {
                  this.dataSourceRecargas.sort = this.sort2;
                  this.dataSourceRecargas.paginator = this.paginator2;
                }, 0);
              }
            });
            //Tabla de dispositivos
              if (this.establecimientoActual && this.establecimientoActual.devices) {
                for(let i=0; i<this.establecimientoActual.devices.length; i++){
                  this.establecimientoDispositivos.push({
                    id: this.establecimientoActual.devices[i].id,
                    dev_reference: this.establecimientoActual.devices[i].dev_reference,
                    dev_label: this.establecimientoActual.devices[i].dev_label,
                    clientId: this.obtenerNombreCliente(this.establecimientoActual.devices[i].dev_cliente_id),
                    dev_create_at: this.establecimientoActual.devices[i].dev_create_at
                  });
                }
              }
              this.dataSource = new MatTableDataSource(this.establecimientoDispositivos);
              this.dataSource.filterPredicate = (data: any, filter: string) => {
                const dataStr = this.displayedColumns
                  .filter(key => key !== 'id')
                  .map(key => data[key])
                  .join('')
                  .toLowerCase();
            
                return dataStr.includes(filter);
              };
              this.dataSource.sort = this.sort1;
              this.dataSource.paginator = this.paginator1;
            //Datos del establecimiento
              this.selectedEstado = this.establecimientoActual.status;
              this.latOriginal = this.establecimientoActual.est_lat;
              this.lngOriginal = this.establecimientoActual.est_lng;
              this.lat = this.establecimientoActual.est_lat;
              this.lng = this.establecimientoActual.est_lng;
              this.signin.setValue({
                contacto: this.establecimientoActual.contacto,
                telefono: this.establecimientoActual.telefono,
                email: this.establecimientoActual.email,
              });
              this.etiqueta = this.establecimientoActual.est_name;
              this.identificador = this.establecimientoActual.external_id;
              this.selectedCliente = this.establecimientoActual.est_cliente_id;
              if(this.selectedCliente !== undefined){
                for (let i = 0; i < this.clientsData.length; i++) {
                  if(this.selectedCliente === this.clientsData[i].id){
                    this.clienteDelEstablecimiento = this.clientsData[i].razon_social
                  }
                }
              }
              //this.nombreCliente = this.establecimientoActual.
              let array = JSON.parse(this.establecimientoActual.est_beertypes);
              if (this.establecimientoActual.est_beertypes) {
                this.cervezasControl.setValue(array);
              }
              let est_img = this.establecimientoActual.est_imgs;
              if(this.establecimientoActual.est_imgs != null){
                this.noHayImage = false;
                this.est_img_path = this.urlBase + "/uploads/imgs/"+ est_img;
              } else {
                this.noHayImage = true;
              }
              if(est_img){
                this.noHayImage = true;
                this.showNoImageError = false;
              }
            //Mapa
            this.mapService.loadMapScript(this.initMap.bind(this));
          }
        });
      }
    });
    //Tipos de cerveza
    this.cervezasControl = this.formBuilder.control([]);
    this.beerTypesSubscription = this.deviceService.getBeerType().subscribe({
      next:resp =>{
        this.cervezas = resp.map((item: any) => ({ value: item.id, name: item.name }));
      }
    });
    //Conseguir el id del establecimiento del path
    this.establecimientoId = this.getDeviceIdFromCurrentPath(this.router);
  }

  initMap(){
    const mapElement = document.getElementById('map');
    // Verificar si el elemento existe antes de intentar trabajar con él
    if (mapElement) {
      const mapOptions = {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
      };
      this.map = new google.maps.Map(mapElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lng },
        map: this.map,
        draggable: false,
        title: 'Marcador'
      });
    } else {
      console.error('Elemento del mapa no encontrado en el DOM.');
    }
    this.getAddress(this.lat, this.lng);
  }

  soloDosDecimalesConComa(numero: number){
    if(Number.isNaN(numero)){
      return 0
    } else {
      return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
    }
  }

  obtenerNombreCliente(id: number): string {
    const cliente = this.clientsData.find((cliente:any) => cliente && cliente.id === id);
    return cliente ? cliente.razon_social : 'Cliente no encontrado';
  }

  obtenerDeviceReference(deviceId: number){
    const device = this.devices.find((device:any) => device && device.id === deviceId);
    return device ? device.dev_reference : "Referencia no encontrada";
  }

  obtenerDeviceLabel(deviceId: number){
    const device = this.devices.find((device:any) => device && device.id === deviceId);
    return device ? device.dev_label : "Etiqueta no encontrada";
  }

  obtenerNombresDeCervezas(): string {
    const idsSeleccionados = this.cervezasControl.value as number[];
    const nombres: string[] = [];

    if(idsSeleccionados != null){
      idsSeleccionados.forEach(id => {
        const cervezaEncontrada = this.cervezas.find(cerveza => cerveza.value === id);
        if (cervezaEncontrada) {
          nombres.push(cervezaEncontrada.name);
        }
      });
    }
    return nombres.join(', ');
  }

  obtenerNombreEstado(valor: number): string | undefined {
    const estadoEncontrado = this.estado.find(e => e.value === valor);
    return estadoEncontrado ? estadoEncontrado.name : undefined;
  }

  updateEstadoErrorEtiqueta() {
    if (!this.etiqueta) {
        this.showEtiquetaError = true;
    } else {
        this.showEtiquetaError = false;
    }
  }

  updateEstadoErrorCliente() {
    if (this.selectedCliente == undefined) {
        this.showClienteError = true;
    } else {
        this.showClienteError = false;
    }
  }

  ngOnDestroy(): void {
    if (this.establishmentSubscription) {
      this.establishmentSubscription.unsubscribe();
    } 
    if (this.beerTypesSubscription) {
      this.beerTypesSubscription.unsubscribe();
    } 
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
    if (this.recargasSubscription) {
      this.recargasSubscription.unsubscribe();
    } 
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  applyFilterRecargas(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceRecargas.filter = filterValue.trim().toLowerCase();
  }

  getDeviceIdFromCurrentPath(router: Router): number {
    const urlTree = router.parseUrl(router.url);
    const segments: UrlSegment[] = urlTree.root.children['primary'].segments;
    // Buscamos el segmento que contiene el número
    let deviceId: number | null = null;
    for (const segment of segments) {
      const value = parseInt(segment.path, 10);
      if (!isNaN(value)) {
        deviceId = value;
        break;
      }
    }
    return deviceId || 0;
  }

  getAddress(latitude: number, longitude: number) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: {lat: latitude, lng: longitude} }).then((response) => {
      //la posicion 0 es el lugar más cercano al click
      if(response.results[0]) {
        this.addressData = response.results[0].formatted_address;
        this.cdr.detectChanges();
      } else{
        this.addressData = "No hay resultados";
      }
    })
  }

  //Cuando se cambia la ubicación en el mapa
  onChoseLocation(event: any){
    this.lat = event.coords.lat;
    this.lng = event.coords.lng;
    this.getAddress(this.lat, this.lng);
  }

  //Cuando se cambian la latitud o longitud manualmente
  updateLocation() {
    this.getAddress(this.lat, this.lng);
  }

  refresh() {
    this.lat = this.latOriginal;
    this.lng = this.lngOriginal
    this.getAddress(this.lat, this.lng);
  }

  onFileSelected(event: any) {
    this.file = event.target.files[0];
    if (this.file && this.file.type === 'image/jpeg') {
      this.previewImage();
      this.showImageErrorMessage = false;
      this.showNoImageError = false;
    } else {
      this.imageUrl = null;
      this.showImageErrorMessage = true;
    }
    if(this.file == undefined){
      this.showImageErrorMessage = false;
    }
  }

  get contactoInput() { 
    return this.signin.get('contacto'); 
  }
  get telefonoInput() { 
    return this.signin.get('telefono'); 
  }
  get emailInput() { 
    return this.signin.get('email'); 
  }

  clearField(fieldName: string) {
    this.signin.get(fieldName)?.setValue('');
  }

  previewImage() {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result;
    };
    reader.readAsDataURL(this.file as Blob);
  }

  get isPhoneNumberValid(): boolean {
    const phoneControl = this.telefonoInput;
    const phoneNumber = phoneControl?.value;
    // Si el número de teléfono está vacío, considerarlo válido
    if (!phoneNumber || phoneNumber.trim() === '') {
      return true;
    }
    const mask = '000 00 00 00'; // Formato utilizado en ngx-mask
    const requiredLength = mask.replace(/[^0]/g, '').length;
    
    return phoneNumber.replace(/[^0-9]/g, '').length === requiredLength;
  }

}

